import { Link, useLocation } from "react-router-dom";
import Header from "../../Layout/Header";
import Profilemenu from "./Profilemenu";
import { useEffect, useState } from "react";
import Rate from "./Ratemodal";
import { completebooking, getBookingTask } from "../../service/Mainservice";
import Loader from "../../Loader/Loader";
import Pagination from "../../Pagination/Pagination";
import "./MyBooking.css";
import moment from "moment";

const Completedbook = () => {
  const [list, setlist] = useState();
  const [load, setload] = useState(true);
  const [openTasks, setOpenTasks] = useState({});
  const [rate, setrate] = useState(false);
  const [currentPage, setcurrentPage] = useState(1);
  const [totalPages, settotalPages] = useState();
  const [selectedbookid, setselectedbookid] = useState(false);

  const location = useLocation();
  const path = location.pathname;
  useEffect(() => {
    getcomplete(1);
  }, []);
  const getcomplete = async (val = 1) => {
    try {
      const response = await completebooking(val);
      const bookingList = response.data.data || [];
      const bookingWithTasks = await Promise.all(
        bookingList.map(async (booking) => {
          try {
            const taskResponse = await getBookingTask(booking.id);
            return {
              ...booking,
              tasks: taskResponse.data?.data || [],
            };
          } catch (error) {
            console.log(error);
            return {
              ...booking,
              tasks: [],
            };
          }
        }),
      );
      setlist(bookingWithTasks);
      setcurrentPage(response.data.pagination.current_pages);
      settotalPages(response.data.pagination.total_pages);

      setload(false);
    } catch (error) {
      setload(false);

      console.log(error);
    }
  };
  const toggleTasks = (id) => {
    setOpenTasks((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  return (
    <>
      <Header title="My Booking" headerbg="completebg" />
      <div className="editprofile_data">
        <Profilemenu />
        <div className="editprofile_info">
          <h2 className="editprofile_maintitle">My Booking</h2>
          <div className="booking_status">
            <Link
              to="/MybookingUpcoming"
              className={
                path === "/MybookingUpcoming"
                  ? "booking_status_title selected_title"
                  : "booking_status_title"
              }
            >
              Upcoming
            </Link>
            <Link
              to="/MybookingCompleted"
              className={
                path === "/MybookingCompleted"
                  ? "booking_status_title selected_title"
                  : "booking_status_title"
              }
            >
              Completed
            </Link>
          </div>
          {list ? (
            <div>
              <div className="mybooking_cardlist">
                {list.map((data) => (
                  <div className="mybooking_card modern_card">
                    <div className="mybooking_card_section">
                      <div className="section_title_div">
                        <p className="section_title">📄 Booking Info</p>
                        <p className="booking_type_badge">
                          {data.booking_type}
                        </p>
                      </div>
                      <div className="mybooking_card_row">
                        <div className="mybooking_cardinfo1">
                          <p>Request ID</p>
                          <h3>{data.request_id}</h3>
                        </div>
                        <div className="mybooking_cardinfo1">
                          <p>Start Date</p>
                          <h3>
                            {moment(data.start_booking_date).format("MM/DD/YY")}
                          </h3>
                        </div>
                        {data.booking_type === "OneTime" && (
                          <div className="mybooking_cardinfo1">
                            <p>End Date</p>
                            <h3>
                              {" "}
                              {moment(data.end_booking_date).format("MM/DD/YY")}
                            </h3>
                          </div>
                        )}
                      </div>
                      <div className="mybooking_card_row">
                        {data.booking_type === "Recurring" &&
                          data.recurring_days.length > 0 && (
                            <div className="mybooking_cardinfo1">
                              <p>Recurring Days</p>
                              <div className="mybooking_days_div">
                                {data.recurring_days.map((day) => (
                                  <h3 className="mybooking_days">
                                    {day.trim()}
                                  </h3>
                                ))}
                              </div>
                            </div>
                          )}
                        {data.booking_type === "Flexible" &&
                          data.flexible_dates.length > 0 && (
                            <div className="mybooking_cardinfo1">
                              <p>Flexible Dates</p>
                              <div className="mybooking_days_div">
                                {data.flexible_dates.map((day) => (
                                  <h3 className="mybooking_days">
                                    {moment(day.trim()).format("MM/DD/YY")}
                                  </h3>
                                ))}
                              </div>{" "}
                            </div>
                          )}
                      </div>
                    </div>
                    <div className="mybooking_card_section">
                      <div className="mybooking_card_row">
                        <div className="mybooking_cardinfo1">
                          <p>Time</p>
                          <h3>{data.booking_time}</h3>
                        </div>
                        <div className="mybooking_cardinfo1">
                          <p>Address</p>
                          <h3>{data.address}</h3>
                        </div>
                      </div>
                    </div>
                    <div className="mybooking_cardup">
                      <div className="mybooking_cardinfo">
                        <p>Companion Assigned</p>
                        <h3 className="mybooking_caretakerdata">
                          <img
                            src={`${process.env.REACT_APP_IMAGE_URL}${data.caregiver_pic}`}
                            alt="caregiver"
                            loading="lazy"
                          />
                          {data.caregiver_name}
                        </h3>
                      </div>
                    </div>
                    <div className="mybooking_card_section mybooking_task_section">
                      <button
                        type="button"
                        className="mybooking_task_toggle"
                        onClick={() => toggleTasks(data.id)}
                      >
                        <div>
                          <p className="section_title mybooking_task_title">
                            Tasks
                          </p>
                          <p className="mybooking_task_count">
                            {data.tasks?.length || 0} task
                            {data.tasks?.length === 1 ? "" : "s"}
                          </p>
                        </div>
                        <span
                          className={`mybooking_task_arrow ${
                            openTasks[data.id] ? "open" : ""
                          }`}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class="lucide lucide-chevron-down-icon lucide-chevron-down"
                          >
                            <path d="m6 9 6 6 6-6" />
                          </svg>{" "}
                        </span>
                      </button>
                      {openTasks[data.id] &&
                        (data.tasks?.length > 0 ? (
                          <div className="mybooking_task_list">
                            {data.tasks.map((task) => (
                              <div
                                className="mybooking_task_item"
                                key={task.id}
                              >
                                <div className="mybooking_task_content">
                                  <h4>{task.task}</h4>
                                  <p>{task.task_time}</p>
                                </div>
                                <span
                                  className={`mybooking_task_status ${
                                    task.status === "completed"
                                      ? "completed"
                                      : "pending"
                                  }`}
                                >
                                  {task.status}
                                </span>
                              </div>
                            ))}
                          </div>
                        ) : (
                          <p className="mybooking_task_empty">No tasks added</p>
                        ))}
                    </div>

                    {data.rate === null ? (
                      <p
                        className="mybooking_help"
                        style={{ cursor: "pointer" }}
                        onClick={() => (setrate(true), setselectedbookid(data))}
                      >
                        Rate Now
                      </p>
                    ) : (
                      <p className="mybooking_help">
                        Rated{"  "}
                        <span>
                          {" "}
                          <svg
                            width="14"
                            height="14"
                            viewBox="0 0 14 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clip-path="url(#clip0_29_684)">
                              <path
                                d="M7.00063 9.91665L3.57179 12.0108L4.50396 8.10248L1.45312 5.48915L5.45771 5.16831L7.00063 1.45831L8.54354 5.16831L12.5487 5.48915L9.49729 8.10248L10.4295 12.0108L7.00063 9.91665Z"
                                fill="#F2B006"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_29_684">
                                <rect width="14" height="14" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                          {data.rate}
                        </span>
                      </p>
                    )}
                  </div>
                ))}
              </div>
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                getorderlist={getcomplete}
              />
            </div>
          ) : (
            <div className="blank_booking">No Complete Bookings</div>
          )}
        </div>
        <Rate
          showRate={rate}
          setShowRate={setrate}
          id={selectedbookid}
          getcomplete={getcomplete}
        />
      </div>
      {load && <Loader />}
    </>
  );
};
export default Completedbook;
